import { render, staticRenderFns } from "./Vervalkota.vue?vue&type=template&id=1b2ca756"
import script from "./Vervalkota.vue?vue&type=script&lang=js"
export * from "./Vervalkota.vue?vue&type=script&lang=js"
import style0 from "./Vervalkota.vue?vue&type=style&index=0&id=1b2ca756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports